var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGobbler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "white",
    stroke: "#16C768"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1226_1493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2723 15.0405C10.251 15.0656 10.2248 15.086 10.1953 15.1006C10.1658 15.1152 10.1336 15.1236 10.1008 15.1253C10.0679 15.127 10.0351 15.1219 10.0042 15.1104C9.97341 15.0989 9.94527 15.0812 9.92153 15.0584L6.07923 11.4218C6.0304 11.3753 6.00196 11.3114 6.0001 11.244C5.99824 11.1766 6.02311 11.1113 6.0693 11.0621L7.29348 9.76858C7.33997 9.71976 7.40388 9.69131 7.47127 9.68945C7.53866 9.68759 7.60405 9.71247 7.65316 9.75865L9.75205 11.7451C9.77579 11.7678 9.80393 11.7855 9.83476 11.797C9.86559 11.8085 9.89844 11.8136 9.9313 11.8119C9.96416 11.8102 9.99633 11.8018 10.0258 11.7872C10.0553 11.7727 10.0815 11.7522 10.1028 11.7271L14.2033 6.96266C14.2474 6.91169 14.3099 6.88026 14.3771 6.87522C14.4444 6.87019 14.5108 6.89197 14.5621 6.9358L15.9118 8.09754C15.9628 8.14167 15.9942 8.20417 15.9993 8.27141C16.0043 8.33864 15.9825 8.40513 15.9387 8.45636L10.2723 15.0405Z",
    fill: "#16C768"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1226_1493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGobbler);
export default __webpack_public_path__ + "static/media/gobbler.54bff21bdd75ab9b786f866942030b05.svg";
export { ForwardRef as ReactComponent };